
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0/Types.js";
import { bool_type, list_type, record_type, option_type, class_type, union_type } from "../../fable_modules/fable-library-js.5.0.0/Reflection.js";
import { IconModule_View } from "../../Components/StenaWebUI/Icons/Icon.js";
import { tryFind, empty as empty_1, ofList } from "../../fable_modules/fable-library-js.5.0.0/Map.js";
import { length, filter as filter_1, sortBy, choose, singleton, empty, ofArray, map } from "../../fable_modules/fable-library-js.5.0.0/List.js";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { Color, theme } from "../../Theme.js";
import { createObj, equals as equals_1, compare, comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { fromHours, fromMinutes } from "../../fable_modules/fable-library-js.5.0.0/TimeSpan.js";
import { minValue, utcNow, op_Subtraction } from "../../fable_modules/fable-library-js.5.0.0/DateOffset.js";
import { SensorId__get_Value, SensorMetaData_$reflection } from "../../StenaWeather.Domain/PortWind.js";
import { ServerError_$reflection } from "../../StenaWeather.WeatherServiceUI.Shared/Errors.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.5.0.0/Result.js";
import { createElement } from "react";
import React from "react";
import { TextModule_View } from "../../Components/StenaWebUI/Core/Text.js";
import { UserSelectType, TextSize, TextVariant } from "../../Components/StenaWebUI/Core/Text.js";
import { SpaceModule_View } from "../../Components/StenaWebUI/Core/Space.js";
import { RowModule_View } from "../../Components/StenaWebUI/Core/Row.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { Page, Router_navigatePage } from "../../Router.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { toText, concat } from "../../fable_modules/fable-library-js.5.0.0/String.js";
import { formatToMultipleUnits } from "../../TimeSpan.js";
import { DateTimeOffset_DateTimeWithTimezone, DateTimeOffset_dateTimeWithTimezone } from "../../Components/TimeZones/Components.js";
import { defaultOf as defaultOf_1 } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { filter, map as map_1, defaultArg } from "../../fable_modules/fable-library-js.5.0.0/Option.js";
import { singleton as singleton_1 } from "../../fable_modules/fable-library-js.5.0.0/AsyncBuilder.js";
import { sleep, catchAsync } from "../../fable_modules/fable-library-js.5.0.0/Async.js";
import { Cmd_OfAsync_eitherAsResult, onPortWindAPI } from "../../Server.js";
import { equals } from "../../fable_modules/fable-library-js.5.0.0/Date.js";
import { Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfAsyncWith_perform } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { AsyncHelpers_start } from "../../fable_modules/Fable.Elmish.5.0.2/prelude.fs.js";
import { ViewHelpers_fallbackDataBanner, autoReloadPeriod } from "./PortWindCommon.js";
import { UseElmishHelper_programWithCustomErrorHandler, React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.5.0.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { cn as cn_5 } from "../Dashboard.js";
import { toArray, empty as empty_2, singleton as singleton_2, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0/Seq.js";
import { PageTitle_title } from "../../SharedView.js";
import { StandardTableModule_view } from "../../Components/StenaWebUI/Grid/StandardTable.js";

export class SensorStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Ok", "Warning", "Error"];
    }
}

export function SensorStatus_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.PortWindStatus.SensorStatus", [], SensorStatus, () => [[], [], []]);
}

function SensorStatusModule_text(_arg) {
    switch (_arg.tag) {
        case 1:
            return "Warning";
        case 2:
            return "Error";
        default:
            return "OK";
    }
}

function SensorStatusModule_icon(status) {
    let t_4, t_7, t_1;
    switch (status.tag) {
        case 1:
            return IconModule_View(ofList(map((value_1) => value_1, ofArray([["size", 10], (t_4 = faCircle, ["icon", t_4]), ["color", theme(new Color(20, []))]])), {
                Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
            }));
        case 2:
            return IconModule_View(ofList(map((value_2) => value_2, ofArray([["size", 10], (t_7 = faCircle, ["icon", t_7]), ["color", theme(new Color(19, []))]])), {
                Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
            }));
        default:
            return IconModule_View(ofList(map((value) => value, ofArray([["size", 10], (t_1 = faCircle, ["icon", t_1]), ["color", theme(new Color(21, []))]])), {
                Compare: (x, y) => (comparePrimitives(x, y) | 0),
            }));
    }
}

function SensorStatusModule_rowBackground(_arg) {
    switch (_arg.tag) {
        case 1:
            return {
                background: theme(new Color(17, [])),
            };
        case 0:
            return {
                background: theme(new Color(1, [])),
            };
        default:
            return {
                background: theme(new Color(16, [])),
            };
    }
}

const fifteenMinutes = fromMinutes(15);

const oneHour = fromHours(1);

function getStatus(now, lastUpdatedOpt) {
    if (lastUpdatedOpt != null) {
        const diff = op_Subtraction(now, lastUpdatedOpt);
        if (diff <= fifteenMinutes) {
            return new SensorStatus(0, []);
        }
        else if (diff <= oneHour) {
            return new SensorStatus(1, []);
        }
        else {
            return new SensorStatus(2, []);
        }
    }
    else {
        return new SensorStatus(2, []);
    }
}

export class Row extends Record {
    constructor(Sensor, LastUpdated, Status) {
        super();
        this.Sensor = Sensor;
        this.LastUpdated = LastUpdated;
        this.Status = Status;
    }
}

export function Row_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.PortWindStatus.Row", [], Row, () => [["Sensor", SensorMetaData_$reflection()], ["LastUpdated", option_type(class_type("System.DateTimeOffset"))], ["Status", SensorStatus_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Load", "OnSensorsLoaded", "OnRowsBuilt"];
    }
}

export function Msg_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.PortWindStatus.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(SensorMetaData_$reflection()), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(SensorMetaData_$reflection())]], [["ErrorValue", ServerError_$reflection()]]])]], [["rows", list_type(Row_$reflection())], ["isFallbackData", bool_type]]]);
}

function StandardTableHelpers_renderStatusCell($props) {
    let p_1_2;
    const p = $props.p;
    const iconEl = SensorStatusModule_icon(p.value);
    const textEl = TextModule_View(ofList(map((value_1) => value_1, ofArray([["variant", new TextVariant(0, [])], ["size", new TextSize(1, [])], ["color", theme(new Color(3, []))], ["userSelect", new UserSelectType(6, [])], ["children", SensorStatusModule_text(p.value)]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }));
    const p_1_3 = ofList(map((value_3) => value_3, singleton(["children", ofArray([iconEl, (p_1_2 = ofList(map((value_2) => value_2, empty()), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }), createElement(SpaceModule_View, {
        p: p_1_2,
    })), textEl])])), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    });
    return createElement(RowModule_View, {
        p: p_1_3,
    });
}

function StandardTableHelpers_renderSensorCell($props) {
    let children;
    const p = $props.p;
    return HtmlHelper_createElement("span", ofArray([["style", {
        cursor: "pointer",
    }], ["onClick", (_arg) => {
        Router_navigatePage(new Page(5, [p.item.Sensor.SensorId]));
    }], ["children", [(children = singleton(p.item.Sensor.Name), createElement("a", defaultOf(), ...children))]]]));
}

function StandardTableHelpers_renderLastUpdatedAgoCell($props) {
    const p = $props.p;
    const matchValue = p.value;
    if (matchValue != null) {
        const dt = matchValue;
        return TextModule_View(ofList(map((value_3) => value_3, singleton(["children", concat(formatToMultipleUnits(op_Subtraction(utcNow(), DateTimeOffset_dateTimeWithTimezone(dt))), ..." ago")])), {
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        }));
    }
    else {
        return TextModule_View(ofList(map((value_1) => value_1, singleton(["children", "No data"])), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }));
    }
}

function StandardTableHelpers_renderLastUpdatedDtCell($props) {
    const p = $props.p;
    const matchValue = p.value;
    if (matchValue != null) {
        const dt = matchValue;
        return TextModule_View(ofList(map((value) => value, singleton(["children", singleton(createElement(DateTimeOffset_DateTimeWithTimezone, {
            dateTime: dt,
        }))])), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }));
    }
    else {
        return defaultOf_1();
    }
}

function StandardTableHelpers_renderDataSourceCell($props) {
    const p = $props.p;
    return defaultArg(map_1((x) => defaultArg(map_1((link) => HtmlHelper_createElement("a", ofArray([["href", link], ["children", [x.Name]]])), x.Link), x.Name), p.value), "Source unknown");
}

export class State extends Record {
    constructor(Rows, IsFallbackData) {
        super();
        this.Rows = Rows;
        this.IsFallbackData = IsFallbackData;
    }
}

export function State_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.PortWindStatus.State", [], State, () => [["Rows", list_type(Row_$reflection())], ["IsFallbackData", bool_type]]);
}

export function init() {
    return [new State(empty(), false), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

function buildRows(clientSessionId, sensors) {
    return singleton_1.Delay(() => singleton_1.Bind(catchAsync(onPortWindAPI(clientSessionId, (api) => api.GetSensorsLastUpdated())), (_arg) => {
        const lastUpdatedRes = _arg;
        let patternInput;
        if (lastUpdatedRes.tag === 1) {
            patternInput = [empty_1({
                Compare: (x_2, y_1) => (compare(x_2, y_1) | 0),
            }), false];
        }
        else {
            const res = lastUpdatedRes.fields[0];
            patternInput = [ofList(choose((x) => {
                if (equals(x.LastUpdated, minValue())) {
                    return undefined;
                }
                else {
                    return [x.SensorId, x.LastUpdated];
                }
            }, res.Sensors), {
                Compare: (x_1, y) => (compare(x_1, y) | 0),
            }), res.IsFallbackData];
        }
        const rows = sortBy((r) => r.Sensor.Name, map((s) => {
            const lu = filter((t) => !equals(t, minValue()), tryFind(s.SensorId, patternInput[0]));
            return new Row(s, lu, getStatus(utcNow(), lu));
        }, sensors), {
            Compare: (x_3, y_2) => (comparePrimitives(x_3, y_2) | 0),
        });
        return singleton_1.Return([rows, patternInput[1]]);
    }));
}

export function update(clientSessionId, msg, state) {
    switch (msg.tag) {
        case 1:
            if (msg.fields[0].tag === 1) {
                return [state, Cmd_none()];
            }
            else {
                const sensors_1 = filter_1((s) => {
                    if (s.Enabled && s.Visible) {
                        return equals_1(s.GroupChildrens, empty());
                    }
                    else {
                        return false;
                    }
                }, msg.fields[0].fields[0]);
                return [state, Cmd_OfAsyncWith_perform((x_1) => {
                    AsyncHelpers_start(x_1);
                }, () => buildRows(clientSessionId, sensors_1), undefined, (tupledArg) => (new Msg(2, [tupledArg[0], tupledArg[1]])))];
            }
        case 2:
            return [new State(msg.fields[0], msg.fields[1]), Cmd_OfAsyncWith_perform((x_2) => {
                AsyncHelpers_start(x_2);
            }, () => sleep(~~autoReloadPeriod), undefined, () => (new Msg(0, [])))];
        default:
            return [state, Cmd_OfAsync_eitherAsResult(() => onPortWindAPI(clientSessionId, (x) => x.GetSensors()), (Item) => (new Msg(1, [Item])))];
    }
}

export function PortWindStatusView($props) {
    const clientSessionId = $props.clientSessionId;
    const state_1 = React_useElmish_Z6C327F2E(() => UseElmishHelper_programWithCustomErrorHandler(undefined, ProgramModule_mkProgram(init, (msg, state) => update(clientSessionId, msg, state), (_arg, _arg_1) => {
    })), undefined, [])[0];
    return HtmlHelper_createElement("div", ofArray([["className", cn_5.className("contentDiv")], ["children", toList(delay(() => append(singleton_2(PageTitle_title("PortWind", "All sensors status")), delay(() => append(state_1.IsFallbackData ? singleton_2(ViewHelpers_fallbackDataBanner("PortWind database is unavailable - showing cached measurements.")) : empty_2(), delay(() => {
        let columnProps, columnProps_1, columnProps_2, columnProps_3, columnProps_4;
        return singleton_2(HtmlHelper_createElement("div", ofArray([["className", cn_5.className("tableWithHeading")], ["children", [StandardTableModule_view(createObj(toList([["variant", "compact"], ["items", toArray(state_1.Rows)], ["loading", length(state_1.Rows) === 0], ["config", createObj(toList([["keyResolver", (i) => SensorId__get_Value(i.Sensor.SensorId)], ["disableSorting", true], ["rowBackgroundResolver", (i_1) => SensorStatusModule_rowBackground(i_1.Status)], ["columns", createObj([(columnProps = createObj(toList([["name", "icon"], ["itemValueResolver", (i_2) => i_2.Status], ["columnLabel", ""], ["width", toText(`${80}px`)], ["renderCell", (p) => createElement(StandardTableHelpers_renderStatusCell, {
            p: p,
        })]])), [columnProps.name, columnProps]), (columnProps_1 = createObj(toList([["name", "sensor"], ["itemValueResolver", (value_6) => {
        }], ["columnLabel", "Sensor"], ["width", toText(`${220}px`)], ["renderCell", (p_1) => createElement(StandardTableHelpers_renderSensorCell, {
            p: p_1,
        })]])), [columnProps_1.name, columnProps_1]), (columnProps_2 = createObj(toList([["name", "lastUpdatedAgo"], ["itemValueResolver", (i_3) => i_3.LastUpdated], ["columnLabel", "Last updated"], ["width", toText(`${180}px`)], ["renderCell", (p_2) => createElement(StandardTableHelpers_renderLastUpdatedAgoCell, {
            p: p_2,
        })]])), [columnProps_2.name, columnProps_2]), (columnProps_3 = createObj(toList([["name", "lastUpdatedDt"], ["itemValueResolver", (i_4) => i_4.LastUpdated], ["columnLabel", "Last updated date time"], ["width", toText(`${220}px`)], ["renderCell", (p_3) => createElement(StandardTableHelpers_renderLastUpdatedDtCell, {
            p: p_3,
        })]])), [columnProps_3.name, columnProps_3]), (columnProps_4 = createObj(toList([["name", "dataSource"], ["itemValueResolver", (i_5) => i_5.Sensor.Source], ["columnLabel", "Data source"], ["width", toText(`${220}px`)], ["renderCell", (p_4) => createElement(StandardTableHelpers_renderDataSourceCell, {
            p: p_4,
        })]])), [columnProps_4.name, columnProps_4])])], ["columnOrder", ["icon", "sensor", "lastUpdatedAgo", "lastUpdatedDt", "dataSource"]]]))]])))]]])));
    }))))))]]));
}

